"use client";

import React from "react";
import CtaBand from "@/components/common/CtaBand";
import { useLanguage } from "@/hooks/useLanguage";
import { pick, type Lang } from "@/lib/i18n";
import { COMMON } from "@/lib/commonCopy";
interface Copy {
  eyebrow: string;
  heading: string;
  lead: string;
  secondaryLabel: string;
}
const copyData: Record<Lang, Copy> = {
  en: {
    eyebrow: "Liquid Process Filtration",
    heading: "Need Custom Liquid Filtration Wire Mesh Specifications?",
    lead: "Submit target micron ratings, operating flow conditions, and alloy requirements for technical evaluation and pricing.",
    secondaryLabel: "Contact Technical Sales"
  },
  zh: {
    eyebrow: "工艺液体过滤",
    heading: "需要定制液体过滤丝网规格或批量报价？",
    lead: "请提供目标拦截微米等级、流体工况及合金材质要求，我们的工程团队将进行技术评估并提供报价。",
    secondaryLabel: "联系技术销售"
  },
  es: {
    eyebrow: "Filtración de líquidos",
    heading: "¿Necesita especificaciones personalizadas de malla para líquidos?",
    lead: "Envíe su grado de micraje objetivo, condiciones de flujo y aleación requerida para recibir una cotización técnica.",
    secondaryLabel: "Contactar ventas técnicas"
  },
  de: {
    eyebrow: "Flüssigkeitsfiltration",
    heading: "Benötigen Sie individuelle Spezifikationen für Flüssigkeitsfilter?",
    lead: "Übermitteln Sie Mikron-Nennwerte, Durchflussbedingungen und Legierungsanforderungen für technische Prüfung und Angebot.",
    secondaryLabel: "Technischen Vertrieb kontaktieren"
  },
  fr: {
    eyebrow: "Filtration des liquides",
    heading: "Besoin de spécifications sur mesure pour la filtration des liquides ?",
    lead: "Transmettez votre seuil de coupure en microns, vos conditions de débit et l'alliage requis pour chiffrage technique.",
    secondaryLabel: "Contacter le service technique"
  },
  pt: {
    eyebrow: "Filtração de líquidos",
    heading: "Necessita de especificações sob medida para filtração de líquidos?",
    lead: "Envie sua classificação micrométrica, condições de fluxo operacional e liga metálica para avaliação e cotação.",
    secondaryLabel: "Fale com vendas técnicas"
  }
};
export default function QuoteCTA() {
  const {
    lang
  } = useLanguage();
  const c = pick(lang, copyData);
  return <CtaBand id="quotecta" eyebrow={c.eyebrow} heading={c.heading} lead={c.lead} primary={{
    label: pick(lang, COMMON.requestQuote),
    to: "/RequestAQuotePage"
  }} secondary={{
    label: c.secondaryLabel,
    to: "/ContactPage"
  }} />;
}